var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.47095C11.2239 3.47095 12.8772 4.15577 14.0962 5.37475C15.3152 6.59374 16 8.24704 16 9.97095C16 11.5809 15.41 13.0609 14.44 14.2009L14.71 14.4709H15.5L20.5 19.4709L19 20.9709L14 15.9709V15.1809L13.73 14.9109C12.59 15.8809 11.11 16.4709 9.5 16.4709C7.77609 16.4709 6.12279 15.7861 4.90381 14.5671C3.68482 13.3482 3 11.6949 3 9.97095C3 8.24704 3.68482 6.59374 4.90381 5.37475C6.12279 4.15577 7.77609 3.47095 9.5 3.47095ZM9.5 5.47095C7 5.47095 5 7.47095 5 9.97095C5 12.4709 7 14.4709 9.5 14.4709C12 14.4709 14 12.4709 14 9.97095C14 7.47095 12 5.47095 9.5 5.47095Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.f702d5961cf151f00e2688619bd344dd.svg";
export { ForwardRef as ReactComponent };